import 'twin.macro';
import 'styled-components/macro';

import { Link } from 'react-router-dom-v5-compat';

import { FillButton, GhostButton } from 'component-lib/atoms/button/Button';

export const AccountActions = (props: React.HTMLProps<HTMLDivElement>) => (
  <div {...props}>
    <Link tw="mr-half" to="/login">
      <GhostButton>Login</GhostButton>
    </Link>
    <Link to="/signup">
      <FillButton>Create account</FillButton>
    </Link>
  </div>
);
